import { render } from "./otp.vue?vue&type=template&id=4a25c6ab&scoped=true"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"

import "./otp.vue?vue&type=style&index=0&id=4a25c6ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a25c6ab"]])

export default __exports__